/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, 
         Route, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import * as fromRoot from '@api/store/app-store';

/**
 * Authentication guard to protect the routes
 */
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  private isAuthenticated: Observable<boolean>;

  /**
   * Creat the instance of AuthGuard
   * @param store The Application strore
   */
  constructor(private store: Store<fromRoot.AppState>) {
    // Start listenning the users's authentication in store
    this.isAuthenticated = store.select(fromRoot.getIsAuthenticated);
  }

  /**
   * Method of CanActivate interface to decide if a route can be activated.
   * @param route The ActivatedRouteSnapshot
   * @param state The RouterStateSnapshot
   * @return Observable boolean
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isAuthenticated;
  }

  /**
   * Method of CanActivateChild interface to decide if a child of this route can be activated.
   * @param route The ActivatedRouteSnapshot
   * @param state The RouterStateSnapshot
   * @return Observable boolean
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }

  /**
   * Method of CanLoad interface to decide if a route can be loaded.
   * @param route The ActivatedRouteSnapshot
   * @return Observable boolean
   */
  canLoad(route: Route): Observable<boolean> {
    return this.isAuthenticated;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/auth-guard.ts